export default __webpack_public_path__ + "static/media/bg_bottom.38ba03ab.png";